import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";

import Page from "@/components/Page";
import Loading from "@/components/Loading";
import Breadcrumbs from "@/components/Breadcrumbs";
import MainActions from "@/components/MainActions";
import CardsContainer from "@/components/CardsContainer";
import CardsList from "@/components/CardsList";
import CardsTable from "@/components/CardsTable";

import AddIcon from "@mui/icons-material/Add";

import {StaffAPI} from "@/api/staff";

import {ERROR_OPERATION} from "@/utils/constants";
import {useTranslation} from "react-i18next";

function ScoutingStaffsPage(props) {
	const {handleNotification} = props;

	const navigate = useNavigate();
	const {t} = useTranslation();

	const seasonId = useSelector((state) => state?.season?.id);

	const [loading, setLoading] = useState(false);
	const [staffs, setStaffs] = useState([]);

	const getStaffs = async () => {
		setLoading && setLoading(true);
		try {
			const response = await StaffAPI.list({prospect: true, seasonId});
			setStaffs(response);
		} catch (error) {
			handleNotification(ERROR_OPERATION, "error");
		} finally {
			setLoading && setLoading(false);
		}
	};

	useEffect(() => {
		getStaffs();
	}, []);

	const listConfiguration = {
		data: staffs,
		onClick: (staff) => navigate("/scouting/staffs/" + staff.id),
	};

	const columns = [
		{label: t("name"), key: "firstName", align: "start"},
		{label: "Cognome", key: "lastName", align: "start"},
		{
			label: "Ruolo",
			key: "role",
			align: "start",
			medium: true,
		},
		{label: "Area", key: "unit", align: "start", medium: true},
	];

	const headerActions = [
		{
			icon: <AddIcon />,
			title: "Aggiungi",
			onClick: () => navigate("/scouting/staffs/new"),
		},
	];

	return (
		<Page>
			<Loading visible={loading} />
			<Breadcrumbs actions={<MainActions actions={headerActions} />} />
			<CardsContainer
				tableComponent={
					<CardsTable
						breadcrumbs
						fullWidth
						configurationColumns={columns}
						data={staffs}
						handleClick={(staff) => navigate("/scouting/staffs/" + staff.id)}
						defaultSortedField="lastName"
						defaultSortedOrder="ascend"
					/>
				}
				listComponent={
					<CardsList
						type="scouting_staff"
						breadcrumbs
						listConfiguration={listConfiguration}
						defaultSortedField="lastName"
						defaultSortedOrder="ascend"
					/>
				}
			/>
		</Page>
	);
}

export default ScoutingStaffsPage;
